import { useMemo } from 'react'

import { useOrgPlan } from '~/hooks/useOrgPlan'
import { PaidPlanName, usePlans } from '~/hooks/usePlans'
import { meetsPlan } from '~/utils/plans'
import { getTimeDiffMs } from '~/utils/time'

/** Whether the active org's plan unlocks a feature, and whether that's enforced yet. */
export const usePlanAccess = (requiredPlan: PaidPlanName) => {
  const orgPlan = useOrgPlan()
  const plans = usePlans()
  const plan = orgPlan.data?.plan
  const { enforcementDate } = plans

  const isEnforced = useMemo(() => {
    if (!enforcementDate) return false
    return getTimeDiffMs(enforcementDate) > 0
  }, [enforcementDate])
  const isAllowed = meetsPlan({
    plans: plans.plans,
    current: plan,
    required: requiredPlan,
  })

  const isLoading = plans.isLoading || orgPlan.isLoading
  const isError = plans.isError || orgPlan.isError

  return {
    isAllowed,
    isEnforced,
    enforcementDate,
    isLoading,
    isError,
    /** Plan qualifies, or enforcement hasn't started; false until loaded. */
    canAccess: !isLoading && !isError && (isAllowed || !isEnforced),
  }
}
